// @ts-check
import { getStringValue, toExcluded } from 'utils/search';

// State -> country rules shared by the main search and org profile reducers so
// the two pages cannot drift. Each state option carries its own `countryName`.

/**
 * Mutates `next` in place after the caller has set or deleted `next[id]`.
 * @param {Record<string, any>} prev filters before this change
 * @param {Record<string, any>} next filters after this change
 * @param {string} id the filter key that changed
 * @param {string} locationCountryKey where the Location country lives on this page
 */
export const applyStateCountryRules = (prev, next, id, locationCountryKey) => {
  if (id === 'state') {
    ensureCountryOfLastState(prev, next, id, locationCountryKey);
  }
  if (id === 'tradeshowState') {
    ensureCountryOfLastState(prev, next, id, 'tradeshowCountryRegion');
  }
};

// Fires only when a state was added, never on removal, so clearing a state
// leaves the country the user may have chosen on purpose.
const ensureCountryOfLastState = (prev, next, id, countryKey) => {
  const prevStates = prev[id] || [];
  const nextStates = next[id] || [];
  if (nextStates.length <= prevStates.length) {
    return;
  }

  const lastState = nextStates[nextStates.length - 1];
  if (!lastState.countryName) {
    console.warn(
      'SciLeads Search',
      `No countryName on ${id} option`,
      lastState
    );
    return;
  }

  next[countryKey] = withCountryIncluded(
    next[countryKey] || [],
    lastState.countryName
  );
};

const withCountryIncluded = (countries, country) => {
  if (countries.includes(country)) {
    return countries;
  }
  if (countries.includes(toExcluded(country))) {
    return countries.map(x =>
      x === toExcluded(country) ? getStringValue(x) : x
    );
  }
  return [...countries, country];
};
